import { FormCadastroEvento } from "interfaces/eventos";

const formCadastroEvento: FormCadastroEvento = {
  formId: "form-cadastro-evento",
  formField: {
    id: {
      name: "id",
      label: "ID",
      type: "number",
    },
    urlBanner: {
      name: "urlBanner",
      label: "Url Banner",
      type: "text",
    },
    urlImageDestaque: {
      name: "urlImageDestaque",
      label: "Url Imagem Destaque",
      type: "text",
    },
    titulo: {
      name: "titulo",
      label: "Título",
      type: "text",
      errorMsg: "Informe título do evento",
    },
    slug: {
      name: "slug",
      label: "Slug",
      type: "text",
      errorMsg: "Slug é obrigatório",
    },
    limiteInscricao: {
      name: "limiteInscricao",
      label: "Limite geral de Inscricão",
      type: "number",
      errorMsg: "Informe o limite de inscricão",
    },
    dataEvento: {
      name: "dataEvento",
      label: "Data Evento",
      type: "date",
      errorMsg: "Informe a data do evento",
    },
    horaLargada: {
      name: "horaLargada",
      label: "Hora Largada",
      type: "time",
      errorMsg: "Informe a Hora Largada",
    },
    inicioIncricao: {
      name: "inicioIncricao",
      label: "Inicio Inscricão",
      type: "date",
      errorMsg: "Informe a data de início das Inscricões",
    },
    horaInicioInsc: {
      name: "horaInicioInsc",
      label: "Hora Inicio Inscricão",
      type: "time",
      errorMsg: "Informe a hora de início das Inscricões",
    },
    fimInscricao: {
      name: "fimInscricao",
      label: "Fim Inscricão",
      type: "date",
      errorMsg: "Informe data do fim das inscricões",
    },
    horaFinalInsc: {
      name: "horaFinalInsc",
      label: "Hora Fim Inscricão",
      type: "time",
      errorMsg: "Informe a hora do fim das inscricões",
    },
    valorServico: {
      name: "valorServico",
      label: "Valor Serviço",
      type: "text",
      errorMsg: "Informe o valor do serviço",
    },
    taxaDescontoBoletoEq: {
      name: "taxaDescontoBoletoEq",
      label: "Desconto para equipes (%)",
      type: "number",
      errorMsg: "Informe a taxa de desconto Boleto",
    },
    taxaInscricao: {
      name: "taxaInscricao",
      label: "Taxa de inscrição",
      type: "text",
      errorMsg: "Informe a taxa de inscricão",
    },
    qtdParcelaCartao: {
      name: "qtdParcelaCartao",
      label: "Quantidade de parcelas no cartão",
      type: "number",
      errorMsg: "Informe qtd Parcela do Cartão",
    },
    dataVencBoleto: {
      name: "dataVencBoleto",
      label: "Data Venc. Boleto",
      type: "date",
      errorMsg: "Informe data venc. Boleto",
    },
    dataVencPix: {
      name: "dataVencPix",
      label: "Data Venc. Pix",
      type: "date",
      errorMsg: "Informe data venc. Pix",
    },
    dataVencCartao: {
      name: "dataVencCartao",
      label: "Data Venc. Cartão",
      type: "date",
      errorMsg: "Informe data venc. Cartão",
    },
    regulamento: {
      name: "regulamento",
      label: "Regulamento",
      type: "text",
    },
    urlRegulamento: {
      name: "urlRegulamento",
      label: "Url Regulamento",
      type: "text",
    },
    resumo: {
      name: "resumo",
      label: "Resumo",
      type: "text",
    },
    urlResumo: {
      name: "urlResumo",
      label: "Url Resumo",
      type: "text",
    },
    termoResp: {
      name: "termoResp",
      label: "Termo Responsabilidade",
      type: "text",
    },
    urlTermoResp: {
      name: "urlTermoResp",
      label: "Url Termo Responsabilidade",
      type: "text",
    },
    infoRetiradaKit: {
      name: "infoRetiradaKit",
      label: "Informação de Retirada de Kit",
      type: "text",
    },
    urlVideoDivulgacao: {
      name: "urlVideoDivulgacao",
      label: "Link do Youtube",
      type: "text",
    },
    urlFacebookDivulgacao: {
      name: "urlFacebookDivulgacao",
      label: "Link ",
      type: "text",
    },
    urlInstagramDivulgacao: {
      name: "urlInstagramDivulgacao",
      label: "Link instagram",
      type: "text",
    },
    exibirMap: {
      name: "exibirMap",
      label: "Exibir Mapa",
      type: "checkbox",
    },
    nomeDoLocal: {
      name: "nomeDoLocal",
      label: "Nome do Local",
      type: "text",
      errorMsg: "Informe o local do evento",
    },
    latitude: {
      name: "latitude",
      label: "🌏 Latitude",
      type: "text",
      errorMsg: "Latitude é obrigatório",
    },
    longitude: {
      name: "longitude",
      label: "🌏 Longitude",
      type: "text",
      errorMsg: "Longitude é obrigatório",
    },
    statusId: {
      name: "statusId",
      label: "Status evento",
      type: "number",
      errorMsg: "Status é obrigatório",
    },
    modalidadeId: {
      name: "modalidadeId",
      label: "Modalidade",
      type: "number",
      errorMsg: "Informe a modalidade",
    },
    tipoServicoId: {
      name: "tipoServicoId",
      label: "Tipo Serviço",
      type: "number",
      errorMsg: "Informe o tipo de serviço",
    },
    isentarMorador: {
      name: "isentarMorador",
      label: "Isentar Morador",
      type: "checkbox",
      errorMsg: "Isentar Morador é obrigatório",
    },
    exibirDestaque: {
      name: "exibirDestaque",
      label: "Exibir Destaque",
      type: "checkbox",
      errorMsg: "Exibir Destaque é obrigatório",
    },
    groupInsc: {
      name: "groupInsc",
      label: "Tipo da inscricão",
      type: "number",
      errorMsg: "Informe o tipo de inscrição Individual ou em grupo",
    },
    exibirListInscrito: {
      name: "exibirListInscrito",
      label: "Exibir Lista de Inscritos",
      type: "text",
      errorMsg: "Informe com será exibido a lista de inscritos",
    },
    urlListaInscrito: {
      name: "urlListaInscrito",
      label: "Url Lista de Inscritos",
      type: "text",
    },
    organizadorId: {
      name: "organizadorId",
      label: "Organizador",
      type: "number",
      errorMsg: "Informe o organizador",
    },
    cep: {
      name: "cep",
      label: "CEP",
      type: "text",
      errorMsg: "Informe Cep",
    },
    logradouro: {
      name: "logradouro",
      label: "Logradouro",
      type: "text",
      errorMsg: "Informe logradouro",
    },
    numero: {
      name: "numero",
      label: "Número",
      type: "text",
      errorMsg: "Informe número logradouro",
    },
    bairro: {
      name: "bairro",
      label: "Bairro",
      type: "text",
      errorMsg: "Informe o bairro",
    },
    cidade: {
      name: "cidade",
      label: "Cidade",
      type: "text",
      errorMsg: "Informe a cidade",
    },
    uf: {
      name: "uf",
      label: "UF",
      type: "text",
      errorMsg: "Informe a UF",
    },
    complemento: {
      name: "complemento",
      label: "Complemento",
      type: "text",
      errorMsg: "informe complemento logradouro",
    },
  },
};

export default formCadastroEvento;
